import { Link, useLocation } from 'react-router-dom';
import { useLang } from '../use-lang';

export function NotFoundRoute() {
  const location = useLocation();
  const { lang } = useLang();

  const t = {
    code: '404',
    heading: lang === 'vi' ? 'Không tìm thấy trang' : 'Page not found',
    body: lang === 'vi' ? (
      <>
        Đường dẫn{' '}
        <code style={{ background: 'var(--color-card, #f3f1ec)', padding: '2px 6px', borderRadius: 4 }}>
          {location.pathname}
        </code>{' '}
        không tồn tại hoặc đã được di chuyển. Bạn có thể quay về trang chủ hoặc thử Hỏi Asklaw.
      </>
    ) : (
      <>
        The path{' '}
        <code style={{ background: 'var(--color-card, #f3f1ec)', padding: '2px 6px', borderRadius: 4 }}>
          {location.pathname}
        </code>{' '}
        does not exist or was moved. You can return home or try Asking Asklaw.
      </>
    ),
    home: lang === 'vi' ? 'Trang chủ' : 'Home',
    ask: lang === 'vi' ? 'Hỏi Asklaw' : 'Ask Asklaw',
  };

  return (
    <main style={{ maxWidth: 560, margin: '96px auto', padding: '0 16px', textAlign: 'center' }}>
      <p
        style={{
          fontFamily: 'var(--font-mono, monospace)',
          fontSize: 13,
          color: 'var(--color-muted, #6b6b6b)',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          marginBottom: 8,
        }}
      >
        {t.code}
      </p>
      <h1 style={{ marginTop: 0 }}>{t.heading}</h1>
      <p style={{ color: 'var(--color-muted)', fontSize: 15, lineHeight: 1.6 }}>{t.body}</p>
      <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 24, flexWrap: 'wrap' }}>
        <Link className="cta-primary" to="/">
          {t.home}
          <span className="arrow" aria-hidden>{'->'}</span>
        </Link>
        <Link className="cta-secondary" to="/chat">
          {t.ask}
        </Link>
      </div>
    </main>
  );
}
